export default "__VITE_ASSET__DPuk5ImO__"